/**
 * Aiká — Página de coleção
 * Abre/fecha o painel de filtros no mobile, e reenvia o formulário
 * automaticamente quando um filtro ou a ordenação muda (sem precisar
 * de botão "aplicar" separado).
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-filter-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = document.querySelector('[data-filter-panel]');
      if (panel) panel.classList.toggle('hidden');
    });
  });

  const form = document.getElementById('AikaFiltersForm');

  const submitForm = () => {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  };

  document.querySelectorAll('[data-filter-input]').forEach((input) => {
    input.addEventListener('change', submitForm);
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', submitForm);
  });
});
